import { useEffect } from 'react';

export default function usePageView() {
    useEffect(() => {
        dataLayer.push({
            event: 'pageview',
            page: window.location.pathname + window.location.search,
        });
    }, []);
}
